import auth0 from 'auth0-js';
import fp from 'lodash/fp';
import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { call, put, select } from 'redux-saga/effects';
import { signUpWithAuth0 } from '../../../../remote-apis';
import { apiActionResult, apiActions as commonApiActions, convertApiAction } from "../../common";
import { auth0ConfigSelector } from '../../configuration/selectors';
import { globalActions } from '../../global';
import { sessionActions } from '../../session';
import { SIGN_UP_ENDPOINT } from './endpoints';
import { userActionTypes } from './util';

const defaultTimezoneName = 'Australia/Sydney'

const actions = createActions({
  USER: {
    SIGN_UP: (signUpPayload, selectedPlan, nextUrl) => ({ signUpPayload, selectedPlan, nextUrl }),
    API: {
      SIGN_UP: userActionTypes()
    }
  }
})

export const apiAction = (authToken, signUpPayload) => commonApiActions.authenticated.post(SIGN_UP_ENDPOINT, authToken, signUpPayload, actions.user.api.signUp)

function* signUpError(response, signUpAction) {
  yield put(convertApiAction(signUpAction.failed(), {
    description: response.error && response.error.description ?
      response.error.description :
      'Something went wrong with sign up, please try again.',
    code: response.error.code
  }));
}

export function* auth0SignUpAndLogin(payload, signUpAction, apiAction, noAuthenticationRedirect) {
  const auth0Config = yield select(auth0ConfigSelector);
  const webAuth = new auth0.WebAuth({
    clientID: auth0Config.clientId,
    domain: auth0Config.domain
  });

  const userMetadata = {
    name: fp.join(' ')([payload.pendingUser.firstName, payload.pendingUser.lastName]),
    firstName: payload.pendingUser.firstName,
    lastName: payload.pendingUser.lastName
  }

  const authResponse = yield call(signUpWithAuth0, payload.pendingUser, userMetadata, webAuth, auth0Config.realm);

  // We have signed up and logged in.
  if (authResponse.isSuccess) {
    yield put(sessionActions.session.authenticate(authResponse.result.idToken, undefined, undefined, undefined, noAuthenticationRedirect));
    // Note that the added pending User property will not be actually persisted, they are required field by Caddie API.
    // The actual values of these properties are overriden by Auth0 issued authentication token, or futher payment gateway webhook calls.
    const nextPendingUser = {
      ...payload.pendingUser,
      userId: '',
      emailVerified: false,
      activated: false,
      isDemo: false,
      timezoneName: defaultTimezoneName
    };

    yield put(apiAction({ idToken: authResponse.result.idToken }, {
      ...payload,
      pendingUser: nextPendingUser,
      industryRoleId: parseInt(payload.industryRoleId, 10)
    }));
    const signUpResult = yield apiActionResult(signUpAction);
    return signUpResult;
  }
  else {
    yield signUpError(authResponse, signUpAction);
    return false;
  }
}

export function* signUp({
  payload: {
    signUpPayload,
    selectedPlan,
    nextUrl
  }
}) {
  const signUpResult = yield* auth0SignUpAndLogin(signUpPayload, actions.user.api.signUp, apiAction, true);
  if (signUpResult && signUpResult.success) {
    yield put(globalActions.onboarding.selectPlan(selectedPlan));
    yield put(push(nextUrl));
  }
}

const configuration = {
  name: 'signUp',
  action: actions,
  sagas: signUp,
  reducers: {
    request: (state, action) => ({
      ...state,
      currentUser: {},
      error: null,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      currentUser: {
        roleAssignments: state.currentUser.roleAssignments,
        teamMemberRoles: state.currentUser.teamMemberRoles,
        ...action.payload.user
      },
      isFetching: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetching: false
    }),
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/signup.js